export default {
  account: '21839570870',
  placements: [
    {
      name: 'sidebar',
      id: 'div-gpt-ad-1578596696331-0',
      sizes: [
        ['fluid'],
      ],
    },
  ],
};
